import type { IController, IAugmentedJQuery, IScope } from 'angular';
import template from './mx-nova-chart-pie.html';
import { I18n } from '../../../i18n/mx-internationalization';
import { AnyObject } from '../../../Types';

type PieChartData = {
	readonly label: string;
	value: number;
	color?: string;
};

class MxNovaChartPieCtrl implements IController {
	static readonly $inject = ['$element', 'mx.internationalization', '$scope'];
	private novaChartEl: IAugmentedJQuery | undefined;
	private data: PieChartData[] = [];
	private selectedItem: AnyObject | undefined;

	constructor(
		private readonly $element: IAugmentedJQuery,
		private readonly i18n: I18n,
		private readonly $scope: IScope
	) {
		$scope.$watch('vm.data', () => this.refreshChartData());
	}

	$postLink() {
		this.novaChartEl = this.$element.find('nova-pie-chart');
		this.novaChartEl[0].addEventListener('left-click', (event) => {
			const index = (event as unknown as CustomEvent).detail.index;

			this.$scope.$evalAsync(() => {
				this.selectedItem = this.data[index];
			});
		});
		this.refreshChartData();
		this.addAccessibility();
	}

	addAccessibility() {
		if (this.novaChartEl) {
			const originalChartStartTemplate =
				this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.chartContainerLabel') +
				' ' +
				this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.chartTypes.pieSingle');
			const defaultTitle = this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.defaultChartTitle');
			const accessibility = {
				chartTitle: defaultTitle.at(-1) === '.' ? defaultTitle.slice(0, -1) : defaultTitle,
				chartStartTemplate: originalChartStartTemplate.replace('{title}', '{chartName}').replace('{numPoints}', '{slicesCount}'),
				chartEndTemplate: this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.endOfChartMarker'),
				chartLegendItemTemplate: this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.legend.legendItem').replace('{itemName}', '{value}'),
				emptyChart: this.i18n.get('solutionBuilderAgent.components.mx-charts.a11y.chartTypes.emptyChart'),
			};
			this.novaChartEl.attr('accessibility', JSON.stringify(accessibility));
		}
	}

	refreshChartData() {
		if (this.data && this.novaChartEl) {
			const chartComputedStyle = getComputedStyle(this.novaChartEl[0]);

			this.data?.forEach((item: { label: string; value: number; color?: string }, i: number) => {
				item.color = chartComputedStyle.getPropertyValue(`--mx-palette-color${(i % 12) + 1}`);
			});
			this.novaChartEl.attr('data', JSON.stringify(this.data));
		}
	}
}

export const mxNovaChartPieComponent = {
	bindings: {
		data: '=',
		showLegend: '=',
		cutout: '=',
		accessibility: '<',
		showTotal: '=',
		isDonut: '=',
		selectedItem: '=?',
	},
	template,
	controllerAs: 'vm',
	controller: MxNovaChartPieCtrl,
};
